import Emitter from "./Emitter";
import EmitterUtils from "../EmitterUtils";

export default class WonAmountChange extends Emitter {

    static lastExecutionDate;

    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler(data) {
        if (data.payload && data.payload.winAmount) {
            const dataForXc = {
                "msgId":"rg2xcGameWonUpdated",
                "value": data.payload.winAmount,
            }

            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
                window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
            } else {
                window.parent.postMessage(JSON.stringify(dataForXc), "*");
            }
        }
    }


    LNWOGS_handler(data) {
        this.gb.wallet.wonAmountChange(data.payload.winAmount / 100);
    }

    SOFTSWISS_handler(data) {
        /*
        SOFTSWISS requires the WonAmountChange event to be sent at the end of each round, even if the won amount is 0.
        Some games are only sending WonAmountChange event is won amount > 0. Due to this limitation, an additional
        WonAmountChange event with amount 0 is triggered for SOFTSWISS wallet on GameSpinEnd (GameSpinEnd.SOFTSWISS_handler) event

        Datetime comparisons are used to avoid sending duplicated requests to SOFTSWISS wallet if the game is sending WonAmountChange event also on amount 0.
         */

        debugger
        let datetimeNow = new Date();
        if (data.payload.winAmount === 0 && WonAmountChange.lastExecutionDate !== undefined
            && datetimeNow.getTime() < EmitterUtils.addToDate(WonAmountChange.lastExecutionDate, EmitterUtils.TimeUnits.MILLISECONDS, 100).getTime()) {
            return; // win amount is 0 and another WonAmountChange event has been sent recently. Avoid duplicated request to be sent.
        }
        WonAmountChange.lastExecutionDate = datetimeNow;

        let winAmountInMajorUnit = data.payload.winAmount / 100;
        let currency = this.gb.settings.currencyCode;
        this.emitParent({type: "a8r:v1:gtp:win_update", payload: { win_amount: winAmountInMajorUnit, currency: currency}});
    }

    _default(msg) {
        const data = msg ? { wpgaction: "wonAmount", payload: msg.payload } : { wpgaction: "wonAmount" };
        const dataParent = msg ? { wpgaction: "wonAmount.parent", payload: msg.payload } : { wpgaction: "wonAmount.parent" };

        this.emitTop(data);
        this.emitParent(dataParent);
        this.emitiOS(data);
    }
}
